import { render, staticRenderFns } from "./Managermessages.vue?vue&type=template&id=256b77d9&"
import script from "./Managermessages.vue?vue&type=script&lang=js&"
export * from "./Managermessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports